import Landing from '../Landing';
import Questionnaire, { Question } from '../Questionnaire';
import Form from '../Form';
import { useEffect, useState } from 'react';
import Message from '../Message';
import { axiosInstance } from '../../config';
import GoogleRecaptcha from '../GoogleRecaptcha';
import { useAppSelector } from '../../store';
import useBackendPath from '../../hooks/useBackendPath';

const QuestionsFormPage = () => {
  const { index } = useAppSelector((state) => state.pagination);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [questions, setQuestions] = useState<Question[]>([]);

  const { backendPath } = useBackendPath();

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(backendPath + '/api/questions', {
        headers: {
          accept: 'application/json',
        },
      })
      .then((res) => res.data)
      .then((data) => {
        setQuestions(data);
      })
      .catch((err) => {
        const message =
          err.response.status >= 500
            ? 'Something went wrong. Please try again later'
            : err.message;
        setError(message);
      })
      .finally(() => setLoading(false));
  }, [backendPath]);

  if (error) {
    return <Message text={error} />;
  }

  if (loading) {
    return <Message text="Loading..." />;
  }

  return (
    <>
      <GoogleRecaptcha />
      {index < 1 && <Landing />}
      {index >= 1 && index <= 10 && <Questionnaire questions={questions} />}
      {index > 10 && <Form />}
    </>
  );
};

export default QuestionsFormPage;
